import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { to: '/', label: '首页' },
    { to: '/category/latest-address', label: '最新地址' },
    { to: '/category/access-guide', label: '访问指南' },
    { to: '/category/tutorials', label: '使用教程' },
    { to: '/category/security-tips', label: '安全须知' },
  ],
  support: [
    { to: '/category/faq', label: '常见问题' },
    { to: '/category/updates', label: '平台动态' },
    { to: '/about', label: '关于我们' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-label font-bold text-sm">
                  91
                </span>
                <span className="font-heading font-semibold text-lg text-background-50">
                  www91导航
                </span>
              </div>
              <p className="text-background-400 text-sm leading-relaxed">
                www91官方入口导航站，提供最新地址、访问指南和常见问题解答，帮助用户安全稳定访问www91平台。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
                快速导航
              </h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.navigation.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-background-400 hover:text-background-100 text-sm transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
                帮助支持
              </h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.support.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-background-400 hover:text-background-100 text-sm transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
                免责声明
              </h4>
              <p className="text-background-400 text-sm leading-relaxed">
                本站为www91官方认可的导航站点，仅提供地址导航和资讯服务，不存储用户数据。请通过本站提供的官方入口访问www91以确保安全。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-background-500 text-xs">
              &copy; {new Date().getFullYear()} www91官方导航. 本站为非商业性质导航站点.
            </p>
            <p className="text-background-500 text-xs">
              收藏本页，永不迷路
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}